import { isSUNY, isTELO, isD2L } from "../../data/email-domains.js";
export const emailChecks = {
  methods: {
    emailBlurred: function() {
      const self = this;
      //console.log('email blurred');

      // // Check if user entered a mru email address
      // if ( !self.isSandboxSignup && self.formdata.email.value.indexOf("mtroyal.ca") !== -1 ) {
      //   self.setMRU();
      // }

      // // Check if user entered a BC email address
      // if (self.formdata.email.value.indexOf(".bc.ca") !== -1) {
      //   self.setBC();
      // }

      // Check if user entered a d2l email address
      if (self.formdata.workflow === "d2lu" && !isD2L(self.formdata.email.value)) {
        self.errors.add({ field: "email", msg: "is not valid" });
        return;
      }

      setTimeout(() => {
        if (!self.checkedEmail) {
          self.checkEmail();
        }
      }, 1000);
    },
    checkEmail: function() {
      const self = this;
      this.checkedEmail = true; // Set the global that this function has run. If ZI fails this won't run and we need to check it to run later.

      if (this.formdata.email.value === "" || self.errors.has("email")) {
        self.checkedEmail = false;
        return; // kickout if the email doesn't have a value
      }

      if (this.formdata.account.value !== "") {
        this.formdata.account.value = "";
        this.formdata.company.value = "";

        this.formdata.company.autofilled = false;
        this.formdata.progressive -= 1;
      }

      if (self.zoominfoData.run) {
        // Check ZoomInfo Status
        let fieldsToCheck = [
          { name: "firstname" },
          { name: "lastname" },
          { name: "company" },
          { name: "title" },
          { name: "industry" },
          {
            name: "phone",
            value: self.formdata.phone.value
          },
          {
            name: "country",
            value: self.getCountryCode(self.zoominfoData.country),
            setFocus: false
          },
          {
            name: "state",
            value: self.zoominfoData.state,
            setFocus: false
          }
        ];

        this.zoominfoCheck(fieldsToCheck); // send the fields above to the checker.

        if (
          this.zoominfoData.meta.enrich_count ===
          this.zoominfoData.meta.field_count
        ) {
          this.zoominfoData.meta.status = "Full match";
        } else if (this.zoominfoData.meta.enrich_count > 0) {
          this.zoominfoData.meta.status = "Partial match";
        }

        // Send event to GA to track enrichment status (no match, partial match or full match) and the fields matched
        dataLayer.push({
          event: "zoominfo",
          "zoominfo-status": this.zoominfoData.meta.status,
          "zoominfo-fields": this.zoominfoData.meta.filled_fields.join(",")
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/exports/methods/emailChecks.js